module.exports = "div.paismarker{font-size:1.5em}\n"